<template>
  <div class="liu">
    <mt-header fixed :title="title" class="title1">
      <mt-button slot="left" icon="back" @click="handleGoBackClick">返回</mt-button>
      <mt-button slot="right" @click="onAgentSumClick">奖励汇总</mt-button>
    </mt-header>
    <div class="scroll-container" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="0">
      <!-- 顶行 -->
      <div class="top-box">
        <div class="between">
          <span> 注册时间:{{ myData.date }} </span>
          <span>
            代理商<span class="link">{{ myData.agentCount }}</span>人
          </span>
          <span class="link" @click="visible.search=true">
            更多 >
          </span>
        </div>
      </div>
      <!-- 空页 -->
      <div v-if="isShowEmptyData"></div>
      <!-- 列表信息 -->
      <div v-if="isShowListData">
        <div class="agent-info-box tmp-top" v-for="(item, index) in myData.list" :key="index">
          <div class="agent-info">
            <div class="agent-user">
              <img :src="item.logoUrl || require('../../assets/image_default_agent@3x.png')" width="44" height="44" />
              <div>
                <div class="lh1">
                  <span class="agent-name">{{ item.name | short }}</span>
                  <span class="agent-star">{{ item.level }}</span>
                </div>
                <div class="agent-date lh1">
                  <span>{{ item.insertDate }}</span>
                </div>
              </div>
            </div>
            <div class="agent-collapse">
              <div class="btn-div">
                <span class="btn-span" @click="onSumClick(item)" v-if="myData.agentLevel==1">奖励汇总 ></span>
              </div>
              <div class="btn-div pt25">
                <span class="link-span" @click="onSvgIconClick(item)">奖励设置 ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 无数据占位图 -->
      <div v-if="isShowNoData">
        <div class="no-data">
          <img src="../../assets/bitmap_agent@3x.png" width="60%" />
          <div class="title-4">
            {{ emptyStartDate + " - " + emptyEndDate + " 暂无新增代理" }}
          </div>
          <div class="title-4"> 点击右上角 <span @click="visible.search = true">更多</span> 查看更多代理商信息 </div>
        </div>
      </div>
    </div>
    <!-- 筛选页面 -->
    <mt-popup class="agent-popup" v-model="visible.search" position="right" :modal="false">
      <div class="agent-content">
        <!-- 标题 -->
        <mt-header fixed title="筛选" class="title2"></mt-header>
        <!-- 内容 -->
        <div class="popup-content">
          <!-- 代理商名 -->
          <div class="content-box">
            <div>
              <span>代理商名称或手机号</span>
            </div>
            <div>
              <input type="text" class="name-mobile w56" v-model="myParam.nameOrMobile" placeholder="请输入代理商名称或手机号" @input="handleAgentNameInputEvent" />
              <img v-show="!search.agent.empty" :src="require('@/assets/clear.png')" alt @click="handleClearSearchAgentClick" />
            </div>
          </div>
          <!-- 注册时间 -->
          <div class="content-box">
            <div>
              <span>注册时间</span>
            </div>
            <div class="no-border">
              <span class="date" @click="handleDateClick('startDate')">{{ picker.startDateText }}</span>
              -
              <span class="date" @click="handleDateClick('endDate')">{{ picker.endDateText }}</span>
            </div>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="more-button">
          <span class="white" @click="handleSearchBtnCancelClick">取消</span>
          <span class="blue" @click="handleSearchBtnSubmitClick">确定</span>
        </div>
      </div>
    </mt-popup>
    <!-- 日期选择 -->
    <mt-datetime-picker ref="datePicker" type="date" :value="picker.selectedDate" :startDate="picker.startDate" :endDate="picker.endDate" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="handleDatePickerConfirm"></mt-datetime-picker>
  </div>
</template>

<script>
import { GetMyAgentListForH5New } from '@/api/agent';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { formatDate } from '@/utils/utils';

export default {
  name: 'TaskRewardSettingList',
  data() {
    return {
      title: '任务奖励设置',
      // 商户
      myData: {
        list: [],
        date: '',
        agentCount: 0,
        total: -1,
        inviteAgent: false,
        scrollDisabled: true,
        agentLevel: '',
      },
      // 查询参数
      myParam: {
        endDate: '',
        level: 0,
        nameOrMobile: '',
        pageNum: 1,
        pageSize: 9,
        productAgentId: '',
        startDate: '',
      },
      // 查询数据
      search: {
        // 星级
        star: {
          list: [],
        },
        // 代理商名
        agent: {
          empty: true,
        },
      },
      // picker时间
      picker: {
        startDateBase: '',
        endDateBase: '',
        startDateText: '',
        endDateText: '',
        startDate: new Date(),
        endDate: new Date(),
        selectedDate: null,
        dateType: '',
      },
      // 显示开关
      visible: {
        search: false,
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'agentdetail') {
      this.$store.commit('setCache', 'Agent');
    } else {
      this.$store.commit('delCache', 'Agent');
    }
    next();
  },
  mounted() {
    this.initData();
  },
  computed: {
    emptyStartDate() {
      return this.picker.startDateText.replace(/\-/g, '.');
    },
    emptyEndDate() {
      return this.picker.endDateText.replace(/\-/g, '.');
    },
    isShowEmptyData() {
      return this.myData.total === -1;
    },
    isShowListData() {
      return this.myData.total > 0;
    },
    isShowNoData() {
      return this.myData.total === 0;
    },
    isShowTopData() {
      return this.myData.list.length !== 1;
    },
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 加载数据
      this.$nextTick(() => {
        this.getDateBase(() => {
          this.getMyData();
        });
      });
    },
    // 通过接口获取数据
    getMyData() {
      CusLoadingOpen();
      // 先设置禁止滚动加载数据
      this.myData.scrollDisabled = true;
      this.myParam.startDate = `${this.picker.startDateText} 00:00:00`;
      this.myParam.endDate = `${this.picker.endDateText} 23:59:59`;
      GetMyAgentListForH5New(this.myParam)
        .then(res => {
          CusLoadingClose();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.myData.date = res.data.date;
            this.myData.agentLevel = res.data.agentLevel;
            this.myData.agentCount = res.data.agentCount;
            // 只在第一次加载列表时存储下total的值，以后不再存储
            this.myData.list.length === 0 && (this.myData.total = res.total);
            if (res.data.responses) {
              // 加入隐藏/显示内容箭头
              res.data.responses.forEach(item => {
                item.visible = false;
                item.svgPath = 'arrow_down';
                item.detail = { monthNewAgent: null, monthNewUser: null, todaySumMoney: null, monthSumMoney: null };
              });
              this.myData.list.push(...res.data.responses);
            }
            // 通过记录条数list.length和数据总数total判断是否查询出所有数据
            // 如果记录条数小于数据总数，则证明没有查询出所有数据，设置允许滚动加载数据
            if (this.myData.list.length < this.myData.total) {
              this.myData.scrollDisabled = false;
            }
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          CusLoadingClose();
          this.myData.list = [];
          this.myData.total = -1;
          this.myParam.pageNum = 1;
          this.myData.scrollDisabled = true;
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      // 通过记录条数list.length和数据总数total判断是否查询出所有数据
      // 如果记录条数小于数据总数，则证明没有查询出所有数据，让lastid等于最后数据的productAgentId
      if (this.myData.list.length && this.myData.list.length < this.myData.total) {
        this.myParam.pageNum += 1;
        this.getMyData();
      }
    },
    // 代理商列表日期查询条件
    getDateBase(callback = null) {
      this.picker.startDateBase = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
      this.picker.endDateBase = new Date();
      this.picker.startDateText = formatDate(this.picker.startDateBase);
      this.picker.endDateText = formatDate(this.picker.endDateBase);
      callback && callback();
    },
    // 日期确定事件
    handleDatePickerConfirm(val) {
      // 根据选择的日期类型判断
      switch (this.picker.dateType) {
        // 开始日期
        case 'startDate':
          // 如果开始日期选择了一个大于当前查询结束日期
          if (val > new Date(this.picker.endDateText)) {
            // 则将查询结束日期自动置为今天的日期
            this.picker.endDateText = formatDate(new Date());
          }
          this.picker.startDateText = formatDate(val);
          break;
        // 结束日期
        case 'endDate':
          this.picker.endDateText = formatDate(val);
          break;
      }
    },
    // 单击日期事件
    handleDateClick(val) {
      // 设置日期类型
      this.picker.dateType = val;
      // 根据选择的日期类型判断
      switch (val) {
        // 开始日期
        case 'startDate':
          // 日期框显示的最大日期：2000-01-01
          this.picker.startDate = new Date('2000-01-01');
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询开始日期
          this.picker.selectedDate = new Date(this.picker.startDateText);
          break;
        // 结束日期
        case 'endDate':
          // 日期框显示的最大日期：默认查询开始日期
          this.picker.startDate = new Date(this.picker.startDateText);
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询结束日期
          this.picker.selectedDate = new Date(this.picker.endDateText);
          break;
      }
      this.$refs.datePicker.open();
    },
    // 查询搜索单击取消事件
    handleSearchBtnCancelClick() {
      this.visible.search = false;
    },
    // 查询搜索单击确定事件
    handleSearchBtnSubmitClick() {
      // 1.滚动条置顶
      window.scrollTo(0, 0);
      // 2.关闭查询窗口
      this.visible.search = false;
      // 3.打开滚动刷新
      this.myData.scrollDisabled = true;
      // 4.重置列表数据
      this.myData.list = [];
      // 5.重置翻页页数
      this.myParam.pageNum = 1;
      // 6.重置总数
      this.myData.total = -1;
      // 7. 加载数据
      this.getMyData();
    },
    // 返回事件
    handleGoBackClick() {
      window.location.href = 'protocol://android';
    },
    // 代理商姓名输入事件
    handleAgentNameInputEvent() {
      this.search.agent.empty = false;
    },
    // 清空筛选框中代理商名称的事件
    handleClearSearchAgentClick() {
      this.myParam.nameOrMobile = '';
      this.search.agent.empty = true;
    },
    // 代理商下拉箭头点击事件
    onSvgIconClick(item) {
      this.$router.push({
        path: '/taskrewardsettingedit',
        query: {
          agentid: item.productAgentId,
          agentlevel: this.myData.agentLevel,
        },
      });
    },
    // 列表中汇总按钮点击事件
    onSumClick(item) {
      this.$router.push({ path: '/taskrewardsettingsum', query: { agentid: item.productAgentId } });
    },
    // 顶部汇总按钮点击事件
    onAgentSumClick() {
      this.$router.push({ path: '/taskrewardsettingsum', query: { agentid: '' } });
    },
  },
  filters: {
    short(val) {
      if (val.length > 10) return val.substr(0, 8) + '…';
      return val;
    },
  },
};
</script>

<style lang="scss" scoped>
.agent-info-box {
  &:nth-child(1) {
    margin-top: 0;

    &.tmp-top {
      margin-top: 2.3rem;
    }
  }

  &:nth-child(2) {
    margin-top: 0.75rem !important;
    background-color: #fff;
  }

  .agent-info {
    .lh1 {
      line-height: 1;
    }

    .agent-date {
      margin-left: 0.6rem;
      padding-top: 0.25rem;
      text-align: left;
    }

    .pt25 {
      padding-top: 0.25rem;
    }
  }
}
</style>
